<template>
  <div class="PreviewBox">
    <el-dialog v-model="Visible" align-center :append-to-body="true" class="PreviewContainer"
      :before-close="closePreview">
      <div class="PreImgBox" @click="closePreview" @mousewheel="mousewheel">
        <el-button type="info" :icon="Close" circle class="closeIcon" @click="closePreview" />
        <img :src="PreviewFile" :style="{ transform: `scale(${scale}) rotate(${rotate}deg)` }"
          @click.stop="defaultClick" />
        <div class="viewer__actions" @click.stop="defaultClick">
          <i class="el-icon" @click.stop="Scale(false)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
              <path fill="currentColor"
                d="m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704zM352 448h256a32 32 0 0 1 0 64H352a32 32 0 0 1 0-64z" />
            </svg>
          </i>
          <i class="el-icon" @click.stop="Scale(true)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
              <path fill="currentColor"
                d="m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704zm-32-384v-96a32 32 0 0 1 64 0v96h96a32 32 0 0 1 0 64h-96v96a32 32 0 0 1-64 0v-96h-96a32 32 0 0 1 0-64h96z" />
            </svg>
          </i>
          <i class="el-icon iconfont icon-xiazai2" @click.stop="downloadFile"></i>
          <i class="el-icon" @click.stop="reset">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
              <path fill="currentColor"
                d="m160 96.064 192 .192a32 32 0 0 1 0 64l-192-.192V352a32 32 0 0 1-64 0V96h64v.064zm0 831.872V928H96V672a32 32 0 1 1 64 0v191.936l192-.192a32 32 0 1 1 0 64l-192 .192zM864 96.064V96h64v256a32 32 0 1 1-64 0V160.064l-192 .192a32 32 0 1 1 0-64l192-.192zm0 831.872-192-.192a32 32 0 0 1 0-64l192 .192V672a32 32 0 1 1 64 0v256h-64v-.064z" />
            </svg>
          </i>
          <i class="el-icon" @click.stop="rotateImg(false)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
              <path fill="currentColor"
                d="M289.088 296.704h92.992a32 32 0 0 1 0 64H232.96a32 32 0 0 1-32-32V179.712a32 32 0 0 1 64 0v50.56a384 384 0 0 1 643.84 282.88 384 384 0 0 1-383.936 384 384 384 0 0 1-384-384h64a320 320 0 1 0 640 0 320 320 0 0 0-555.712-216.448z" />
            </svg>
          </i>
          <i class="el-icon" @click.stop="rotateImg(true)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
              <path fill="currentColor"
                d="M784.512 230.272v-50.56a32 32 0 1 1 64 0v149.056a32 32 0 0 1-32 32H667.52a32 32 0 1 1 0-64h92.992A320 320 0 1 0 524.8 833.152a320 320 0 0 0 320-320h64a384 384 0 0 1-384 384 384 384 0 0 1-384-384 384 384 0 0 1 643.712-282.88z" />
            </svg>
          </i>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Close } from "@element-plus/icons-vue";
export default {
  props: {
    showVisible: {
      type: Boolean,
      default: false
    },
    PreviewFile: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      Visible: false,
      Close,
      scale: 1,
      rotate: 0
    };
  },
  watch: {
    showVisible: {
      handler: function (val) {
        this.Visible = val;
        if (val) {
          window.parent.postMessage(
            {
              IsShowList: true,
            },
            "*"
          );
          this.$nextTick(() => {
            var child = document.querySelector('.PreviewContainer ');
            // 为子元素添加事件监听器
            child.addEventListener('mousewheel', function (event) {
              event.preventDefault();
            }, { passive: false });
          })

        }
        this.reset();
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {

  },
  methods: {
    closePreview() {
      window.parent.postMessage(
        {
          IsShowList: false,
        },
        "*"
      );
      this.$emit("closePreview");
    },
    //下载文件
    downloadFile() {
      if (this.PreviewFile) {
        window.open(this.PreviewFile, "_blank");
      }
    },
    mousewheel(e) {
      if (e.deltaY > 0) {
        if (this.scale <= 0.19) {
          return;
        }
        this.scale -= 0.1;
      } else {
        this.scale += 0.1;
      }
    },
    Scale(val) {
      if (val) {
        this.scale += 0.1;
      } else {
        if (this.scale <= 0.19) {
          return;
        }
        this.scale -= 0.1;
      }
    },
    reset() {
      this.scale = 1;
      this.rotate = 0;
    },
    rotateImg(val) {
      if (val) {
        this.rotate += 90;
      } else {
        this.rotate -= 90;
      }
    }
  }
};
</script>
<style lang="less">
.PreviewContainer {
  background: none;
  height: 100%;
  width: 100%;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;

    .PreImgBox {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      width: 100vw;
      position: fixed;

      img {
        width: auto;
        height: auto;
        max-height: 100%;
        max-width: 100%;
      }

      .closeIcon {
        position: fixed;
        right: 50px;
        top: 50px;
        height: 44px;
        width: 44px;
        z-index: 9;
      }

      .viewer__actions {
        position: fixed;
        left: 50%;
        bottom: 50px;
        transform: translate(-50%);
        width: 282px;
        height: 44px;
        padding: 0 23px;
        background-color: var(--el-text-color-regular);
        border-color: #fff;
        border-radius: 22px;
        display: flex;
        justify-content: space-around;
        align-items: center;

        .el-icon {
          color: #fff;
          height: 22px;
          width: 22px;
        }
      }
    }
  }
}
</style>
